import Colors from '../../../../theme/colors';
import Dimens from '../../../../theme/dimens';
import { OrgStatus } from '../../../../utils/constants';
import { Props } from '.';
import ThemeUtil from '../../../../theme/theme-util';
import { useTheme } from '@mui/material';

/**
 * useStyles custom hook generates MUI theme dependent styles for the OrganizationListItem component.
 * @param {UseStylesProps} props - Props passed from the component to determine dynamic styles.
 * @returns An object containing the styled classes.
 */
const useStyles = (props: Props, isSelected = false) => {

  const { xs, md, lg, section } = Dimens.spacing;
  const theme = useTheme();
  const status = props.organization.status;

  const styles = {
    listItem: {
      p: `${lg} ${section}`,
      borderBottom: `${Dimens.menuBorderWidth} solid ${theme.palette.divider}`,
      bgcolor: isSelected ? theme.palette.background.default : 'unset',
      flexGrow: 0,
      [theme.breakpoints.down('sm')]: {
        p: lg
      }
    },
    avatar: {
      width: Dimens.avatarSize,
      height: Dimens.avatarSize,
      color: theme.palette.primary.contrastText,
      bgcolor: ThemeUtil.isLightTheme(theme) ? theme.palette.text.primary : Colors.palette.secondary[300]
    },
    avatarWrapper: {
      minWidth: 0
    },
    textEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    textWrapper: {
      p: `0 ${lg}`,
      m: 0,
      display: 'inline-grid',
      whiteSpace: 'nowrap'
    },
    primaryText: {
      fontWeight: Dimens.fontWeight.bold,
      color: theme.palette.text.primary
    },
    secondaryText: {
      color: theme.palette.text.secondary
    },
    status: {
      p: `${xs} ${md}`,
      borderRadius: Dimens.radius.md,
      minWidth: Dimens.statusBtnMinWidth,
      textAlign: 'center'
    },
    statusDynamic: {
      ...(status === OrgStatus.Active && {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
      }),
      ...(status === OrgStatus.Draft && {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.text.secondary,
      }),
      ...(status === OrgStatus.Inactive && {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.error.main,
      }),
    }
  };

  return styles;
};

export default useStyles;